import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=3cb81a8a&scoped=true&"
import script from "./VCheckbox.vue?vue&type=script&lang=js&"
export * from "./VCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=3cb81a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb81a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb81a8a')) {
      api.createRecord('3cb81a8a', component.options)
    } else {
      api.reload('3cb81a8a', component.options)
    }
    module.hot.accept("./VCheckbox.vue?vue&type=template&id=3cb81a8a&scoped=true&", function () {
      api.rerender('3cb81a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VCheckbox.vue"
export default component.exports